/** Task routing artefact types and build item types (brief §22.4.4). */
export const ROUTING_ARTEFACT_TYPES = [
  'Requirement',
  'Disposition',
  'Build item',
  'Functional spec',
  'Test script',
  'Defect',
  'Gate condition',
];

export const ROUTING_TEST_TYPES = ['unit', 'integration', 'uat'];

export const ROUTING_BUILD_ITEM_TYPES = [
  'OOTB',
  'Config',
  'Workflow',
  'Report',
  'Interface',
  'Conversion',
  'Enhancement',
  'Form',
  'Data Migration',
];

export const ROUTING_TASK_TYPES = [
  { key: 'approval', label: 'Approval' },
  { key: 'work', label: 'Work' },
  { key: 'review', label: 'Review' },
  { key: 'assignment', label: 'Assignment' },
];

/** Warn when task type conflicts with role is_delegating flag (§22.4.7). */
export function routingMismatch(role, taskType) {
  if (!role) return false;
  if (taskType === 'assignment') return !role.is_delegating;
  if (['approval', 'work', 'review'].includes(taskType)) return role.is_delegating;
  return false;
}

export function mismatchHint(role, taskType) {
  if (!routingMismatch(role, taskType)) return null;
  if (taskType === 'assignment') {
    return `${role.full_name} is non-delegating — Assignment tasks expect a delegating lead.`;
  }
  return `${role.full_name} is delegating — ${taskType} tasks usually go to a non-delegating role.`;
}
